import fetch from 'isomorphic-fetch';
import { checkStatus } from '../../util';
import { drawGeom } from '../../../businessLogic/map';
import { ROOT } from '../../../constants/root';
import { filterShapes, keywordsById } from '../reducer';
import { filterByKeywords } from '../../../businessLogic/util';
import { getDocumentPoints } from '../actions';

export function getGeom(id, map, drawPoints = true, module = "documents", callback) {
	return function(dispatch, getState) {		

		const cache = window.geomCache;
		if (cache && id in cache) {
			const cached = cache[id];
			// return processGeom(id, getState, cached, map, drawPoints, module, callback);	
			return new Promise((resolve, reject) => {
				resolve(processGeom(id, getState, cached, map, drawPoints, module, callback));	
			});
		}

		const URL = `${ROOT}/shape/${id}/`;		

		return fetch(URL, {
			method: 'GET',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			addGeomToCache(id, json);
			processGeom(id, getState, json, map, drawPoints, module, callback);
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

function processGeom(id, getState, json, map, drawPoints, module, callback) {
	if ( json.geom.length === 0 ) return;
	if ( json.shapeType === 3 && !drawPoints ) return;
	
	if ( module === "keywords" ) {
		const selectedKeywords = keywordsById(getState().explorer.filter);				
		const documents = getState().explorer.documents;
		
		let shouldReturn = true;
		filterByKeywords(documents, selectedKeywords).map((d) => {		
			d.shapes.map((s) => {
				if ( s === id ) shouldReturn = false;
			});
		});
		if ( shouldReturn ) return;
	} else if ( module === "locations") {
		// Do nothing special, just draw
	} else {
		let array = [];
		if ( module === "documents" ) array = filterShapes(getState().documents.current);
		else if ( module === "explorer" ) array = filterShapes(getState().explorer.filter);	

		if ( array.indexOf(id) === -1 ) return;
	}
	const selectedProjects = getState().login.choosenbyuser;

	if (json.projeto === 1 && selectedProjects.isMariana === true || 
		json.projeto === 2 && selectedProjects.isBrumadinho === true) {
	//	isFetchingMap(false);

		drawGeom(map, json.geom, id, json.shapeType, json.name, () => {
			if (callback) callback();
		});
	}
}

export function addGeomToCache(index, geom) {
	if (!window.geomCache) window.geomCache = [];

	window.geomCache[index] = geom;
}

export function setSectors(sectors) {
	return {
		type: "SET_SECTORS",
		sectors
	};	
}

export function setLocalities(localities) {
	return {
		type: "SET_LOCALITIES",
		localities
	};	
}

export function setSamplingPoints(samplingPoints) {
	return {
		type: "SET_SAMPLING_POINTS",
		samplingPoints
	};	
}

export function setPoints(points, hasEdited = true) {
	return {
		type: "SET_POINTS",
		points,
		hasEdited
	};		
}

export function createPoint(options = {}) {
	
	let _options = {
		lat: "",
		lng: "",
		label: "",
		datetime: null,
		timezone: "",
		file: null,
		isCreating: false
	};
	const opts = { ..._options, ...options };
	return {
		type: opts.file ? "CREATE_POINT_WITH_IMAGE" : "CREATE_POINT",
		lat: opts.lat,
		lng: opts.lng,
		label: opts.label, 
		datetime: opts.datetime,
		timezone: opts.timezone,
		file: opts.file, 
		isCreating: opts.isCreating
	};		
}

export function createPointRaw(newPoint) {
	return {
		type: "CREATE_POINT_RAW",
		newPoint
	};
}

export function setIsCreatingPoint(index, value) {
	return {
		type: "SET_IS_CREATING_POINT",
		index,
		value
	};
}

export function removePoint(index) {
	return {
		type: "REMOVE_POINT",
		index
	};		
}

export function addPointImage(index) {
	return {
		type: "ADD_POINT_IMAGE",
		index
	};		
}

export function addPointImageWithSrc(index, source, datetime = "", filehash = "") {
	return {
		type: "ADD_POINT_IMAGE_WITH_SOURCE_AND_DATETIME",
		index,
		source,
		datetime,
		filehash
	};
}

export function removePointImage(i, j) {
	return {
		type: "REMOVE_POINT_IMAGE",
		i,
		j
	};		
}

export function removeSavedPoint(id) {
	return function(dispatch, getState) {		

		const URL = `${ROOT}/point/${id}/`;
		return fetch(URL, {
			method: 'DELETE',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => {
			// Last param in URL
			const documentId = window.location.pathname.split("/").slice(-1)[0];
			dispatch(getDocumentPoints(documentId));
		})		
		.catch((e) => {
			alert(e);			
		});
	};
}

export function removeSavedPointImage(id) {
	return function(dispatch, getState) {		

		const URL = `${ROOT}/picture/${id}/`;
		return fetch(URL, {
			method: 'DELETE',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			}
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			// Last param in URL
			const documentId = window.location.pathname.split("/").slice(-1)[0];
			dispatch(getDocumentPoints(documentId));
		})		
		.catch((e) => {
			alert(e);			
		});
	};
}

export function setPointSrc(i, j, src) {
	return {
		type: "SET_POINT_SRC",
		i, // Point index
		j, // Image index
		src
	};		
}

export function setPointCaption(i, j, caption) {
	return {
		type: "SET_POINT_CAPTION",
		i,
		j,
		caption
	};		
}

export function setSavedPointCaption(i, j, caption) {
	return {
		type: "SET_SAVED_POINT_CAPTION",
		i,
		j,
		caption
	};		
}

export function setLat(lat, index) {
	return {
		type: "SET_LAT",
		lat,
		index
	};		
}

export function setLng(lng, index) {
	return {
		type: "SET_LNG",
		lng,
		index
	};		
}

export function setPointLabel(label, index) {
	return {
		type: "SET_LABEL",
		label,
		index
	};		
}

export function createRect(options = {}) {

	let _options = {
		isCreating: false
	};
	const opts = { ..._options, ...options };
	return {
		type: "CREATE_RECT",
		isCreating: opts.isCreating
	};		
}

export function removeRect(index) {
	return {
		type: "REMOVE_RECT",
		index
	};		
}

export function setIsCreatingRect(index, value) {
	return {
		type: "SET_IS_CREATING_RECT",
		index,
		value
	};
}

export function setLatNw(lat, index) {
	return {
		type: "SET_LAT_NW",
		lat,
		index
	};		
}

export function setLngNw(lng, index) {
	return {
		type: "SET_LNG_NW",
		lng,
		index
	};		
}

export function setLatSe(lat, index) {
	return {
		type: "SET_LAT_SE",
		lat,
		index
	};		
}

export function setLngSe(lng, index) {
	return {
		type: "SET_LNG_SE",
		lng,
		index
	};		
}


// WEBPACK FOOTER //
// ./src/state/documents/local/actions.js